var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomIcon = function SvgZoomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H4.4c-.9 0-1.7-.5-2.2-1.3-.5-.9-.3-2 .4-2.8L12 5.4H5.4C3.5 5.4 2 3.9 2 2h12.5c.9 0 1.7.5 2.2 1.3.5.9.3 2-.4 2.8l-9.4 9.5h7.8c1.8 0 3.3 1.5 3.3 3.4z"
  })));
};
export default SvgZoomIcon;